import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes, faUser, faPhone, faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons';
import baseURL from '../../url';

export default function NewContact({ onCreated }) {
  const [nombre, setNombre] = useState('');
  const [telefono, setTelefono] = useState('');
  const [instagram, setInstagram] = useState('');
  const [email, setEmail] = useState('');
  const [direccion, setDireccion] = useState('');
  const [facebook, setFacebook] = useState('');

  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const resetForm = () => {
    setNombre('');
    setTelefono('');
    setInstagram('');
    setEmail('');
    setDireccion('');
    setFacebook('');
  };

  const toggleModal = () => {
    if (!modalOpen) {
      resetForm();
    }
    setModalOpen(!modalOpen);
  };

  // Función para validar todos los campos
  const validateForm = () => {
    const errors = [];
    
    if (!nombre.trim()) errors.push('Nombre');
    if (!telefono.trim()) errors.push('Teléfono');
    if (!instagram.trim()) errors.push('Instagram');
    if (!email.trim()) errors.push('Email');
    if (!direccion.trim()) errors.push('Dirección');
    if (!facebook.trim()) errors.push('Facebook');
    
    return errors;
  };

  // Verificar si el formulario es válido
  const isFormValid = () => {
    return nombre.trim() && 
           telefono.trim() && 
           instagram.trim() && 
           email.trim() && 
           direccion.trim() && 
           facebook.trim();
  };

  const crear = async () => {
    console.log('🚀 Iniciando creación de contacto');
    const errors = validateForm();
    
    if (errors.length > 0) {
      console.log('❌ Errores de validación:', errors);
      alert(`Los siguientes campos son obligatorios: ${errors.join(', ')}`);
      return;
    }

    console.log('✅ Validación pasada, enviando datos:', {
      nombre: nombre.trim(),
      telefono: telefono.trim(),
      instagram: instagram.trim(),
      email: email.trim(),
      direccion: direccion.trim(),
      facebook: facebook.trim()
    });

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('nombre', nombre.trim());
      formData.append('telefono', telefono.trim());
      formData.append('instagram', instagram.trim());
      formData.append('email', email.trim());
      formData.append('direccion', direccion.trim());
      formData.append('facebook', facebook.trim());

      console.log('📤 Enviando request a:', `${baseURL}/contactoPost.php`);
      
      const resp = await fetch(`${baseURL}/contactoPost.php`, {
        method: 'POST',
        body: formData,
      });

      console.log('📥 Response status:', resp.status);
      console.log('📥 Response headers:', Object.fromEntries(resp.headers.entries()));

      // Try JSON first, fall back to text for debugging
      let data;
      let responseText;
      try {
        responseText = await resp.text();
        console.log('📄 Raw response:', responseText);
        data = JSON.parse(responseText);
        console.log('📋 Parsed data:', data);
      } catch (e) {
        console.error('❌ Error parsing JSON:', e);
        console.error('❌ Raw response was:', responseText);
        throw new Error('Respuesta no válida del servidor');
      }

      if (!resp.ok) {
        console.log('❌ HTTP error response:', resp.status);
        throw new Error(data?.error || 'Error al crear el contacto');
      }

      if (data?.mensaje) {
        console.log('✅ Contacto creado exitosamente:', data);
        alert('Contacto creado exitosamente');
        if (typeof onCreated === 'function') onCreated();
        toggleModal();
      } else {
        console.log('❌ No se recibió mensaje de éxito:', data);
        throw new Error(data?.error || 'No se pudo crear el contacto');
      }
    } catch (err) {
      console.error('❌ Error completo:', err);
      alert(err.message || 'Error de conexión. Por favor, inténtalo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Botón trigger con estilos globales */}
      <button onClick={toggleModal} className="btn-product-primary flex-center">
        <FontAwesomeIcon icon={faPlus} />
        Agregar contacto
      </button>

      {/* Modal con sistema global */}
      {modalOpen && (
        <div className="product-modal-backdrop">
          <div className="product-modal-container" style={{ maxWidth: 900 }}>
            {/* Header */}
            <div className="product-modal-header">
              <div className="product-modal-title">
                <FontAwesomeIcon icon={faPlus} />
                Nuevo contacto
              </div>
              <button className="product-close-button" onClick={toggleModal}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

            {/* Body */}
            <div className="product-modal-body">
              <div className="product-section-card mb-24">
                <div className="product-section-header">
                  <div className="product-section-title flex-center">
                    <FontAwesomeIcon icon={faUser} />
                    Datos del contacto
                  </div>
                </div>

                <div className="product-section-content">
                  {/* Grid responsive simple */}
                  <div className="grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                    <div className="product-form-group">
                      <label className="product-form-label">
                        <FontAwesomeIcon icon={faUser} /> Nombre *
                      </label>
                      <input
                        type="text"
                        className="product-form-input"
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                        placeholder="Nombre"
                        maxLength={100}
                        required
                      />
                    </div>

                    <div className="product-form-group">
                      <label className="product-form-label">
                        <FontAwesomeIcon icon={faPhone} /> Teléfono *
                      </label>
                      <input
                        type="tel"
                        className="product-form-input"
                        value={telefono}
                        onChange={(e) => setTelefono(e.target.value)}
                        placeholder="Teléfono"
                        maxLength={30}
                        required
                      />
                    </div>

                    <div className="product-form-group">
                      <label className="product-form-label">
                        <FontAwesomeIcon icon={faInstagram} /> Instagram (URL) *
                      </label>
                      <input
                        type="url"
                        className="product-form-input"
                        value={instagram}
                        onChange={(e) => setInstagram(e.target.value)}
                        placeholder="https://instagram.com/usuario"
                        required
                      />
                    </div>

                    <div className="product-form-group">
                      <label className="product-form-label">
                        <FontAwesomeIcon icon={faFacebook} /> Facebook *
                      </label>
                      <input
                        type="text"
                        className="product-form-input"
                        value={facebook}
                        onChange={(e) => setFacebook(e.target.value)}
                        placeholder="@facebook"
                        maxLength={80}
                        required
                      />
                    </div>

                    <div className="product-form-group">
                      <label className="product-form-label">
                        <FontAwesomeIcon icon={faEnvelope} /> Email *
                      </label>
                      <input
                        type="email"
                        className="product-form-input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="correo@dominio.com"
                        maxLength={120}
                        required
                      />
                    </div>

                    <div className="product-form-group">
                      <label className="product-form-label">
                        <FontAwesomeIcon icon={faMapMarkerAlt} /> Dirección *
                      </label>
                      <input
                        type="text"
                        className="product-form-input"
                        value={direccion}
                        onChange={(e) => setDireccion(e.target.value)}
                        placeholder="Dirección"
                        maxLength={160}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer (acciones) */}
            <div className="product-submit-section">
              <button className="btn-product-secondary" onClick={toggleModal} disabled={loading}>
                Cancelar
              </button>
              <button
                className="btn-product-primary"
                onClick={crear}
                disabled={loading || !isFormValid()}
                title={!isFormValid() ? 'Todos los campos son obligatorios' : 'Crear'}
              >
                {loading ? 'Procesando…' : 'Agregar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}